import { Component } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MessageService, PrimeNGConfig } from "primeng/api";
import { StateService } from "./services/state.service";
import { ThemeService } from "./services/theme.service";
import { TitleService } from "./services/title.service";
import { PRIMENG_LOCALES } from "./shared/primeng-locale.constants";
import { setAppLocale } from "./utils/localized-date.util";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MessageService],
})
export class AppComponent {
  title = "catMan-ui";
  result: any;
  toastMarginClass: "right-toolbar-open" | "right-toolbar-close" =
    "right-toolbar-open";

  constructor(
    public stateService: StateService,
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public translate: TranslateService,
    private titleService: TitleService,
    public themeService: ThemeService,
    private primengConfig: PrimeNGConfig
  ) {
    //translation

    translate.addLangs(["en", "pt", "es", "fr", "nl", "ko", "de"]);
    translate.setDefaultLang("en");
    translate.use("en");

    // Keep PrimeNG's own built-in UI strings (calendar month/day names, apply/clear, etc.)
    // in sync with the app language, since PrimeNG does not use ngx-translate.
    // Merge `aria` with PrimeNG's defaults: setTranslation replaces it wholesale and
    // components like the paginator/table read keys (e.g. aria.pageLabel) the locales omit.
    const applyPrimeLocale = (lang: string) => {
      const locale = PRIMENG_LOCALES[lang] || PRIMENG_LOCALES["en"];
      this.primengConfig.setTranslation({
        ...locale,
        aria: { ...this.primengConfig.translation.aria, ...locale.aria },
      });
    };
    applyPrimeLocale("en");
    translate.onLangChange.subscribe(({ lang }) => {
      setAppLocale(lang);
      applyPrimeLocale(lang);
    });

    // const browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    if (!mac) {
      window.document.body.id = "custom-scrollbar";
    }

    this.route.queryParams.subscribe((params: any) => {
      if (params.access_token && params.refresh_token) {
        window.localStorage.c = params.access_token;
        window.localStorage.d = params.refresh_token;
        window.localStorage.i = params.id;
        // This is the first time here we set the tokenExpiryDate
        this.stateService.setTokenExpiryDate();

        let redirectURL =
          sessionStorage.getItem("callbackURL") || this.getDefaultDomainRoute();

        // var currentUrl =
        //   this.stateService.removeQueryParamsFromUrl(redirectURL);
        // this.router.navigate([currentUrl], {
        //   replaceUrl: true,
        // });

        if (redirectURL) {
          const urlTree = this.router.parseUrl(redirectURL);

          // Extract the path safely
          const path =
            urlTree.root.children["primary"]?.segments
              .map((segment) => segment.path)
              .join("/") || "";

          // Extract query parameters safely
          const queryParams = Object.keys(urlTree.queryParams).length
            ? urlTree.queryParams
            : null;

          // Navigate with or without query params
          this.router.navigate([path], {
            ...(queryParams ? { queryParams } : {}), // Add query params only if they exist
            replaceUrl: true,
          });
        }
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.titleService.setDefaultTitle();
        this.titleService.setFavicon();
      }
    });
    this.openToast();
    this.openSoftWarningToast();
  }

  closeDownloadToast() {
    this.stateService.isDownload = false;
    this.messageService.clear("downloadToast");
  }
  openToast() {
    this.stateService.Result.subscribe((data: any) => {
      this.messageService.add({
        key: "downloadToast",
        severity: "info",
        summary: "Warn Message",
        sticky: true,
        closable: false,
      });
    });
  }
  openSoftWarningToast() {
    this.stateService.openSoftWarningToast.subscribe((data: any) => {
      if (data) {
        this.toastMarginClass = data["marginClass"];
        this.messageService.add({
          key: "softWarningToast",
          severity: "info",
          summary: "Warn Message",
          detail: data["message"],
          life: 5000,
          closable: false,
        });
      }
    });
  }
  closeSoftWarningToast() {
    this.messageService.clear("softWarningToast");
  }

  private getDefaultDomainRoute(): string {
    const domainType = this.stateService.checkAppConfig();
    const hostname = window.location.hostname;

    if (domainType === "ai-imagery") {
      return "/ai-imagery";
    } else {
      return "/studio";
    }
  }
}
